<template>
    <div :class="{'row': !isFloat}">
        <div v-if="!isFloat" class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group" :class="{ 'form-group--float': isFloat, 'col-sm-8': !isFloat, 'form-group--centered': isCentered }">
        <textarea class="form-control textarea-autosize" :id="id" :name="name" :value="value"
                  :class="[{ 'form-control--active': isLabelFloatActive, 'is-invalid': errors.has(name)}, getSizeClass]"
                  v-validate="getValidators" :data-vv-as="label"
                  @input="$emit('input', $event.target.value)"></textarea>
            <label v-if="isFloat">{{ label }}</label>
            <i class="form-group__bar"></i>
        </div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    import autosize from 'autosize'

    export default {
        mixins: [formElementMixin],

        computed: {
            element() {
                return $('.textarea-autosize', this.$el)
            }
        },

        mounted() {
            autosize(this.element);
        },

        destroyed() {
            autosize.destroy(this.element)
        }
    }
</script>

<style lang="scss" scoped>
    textarea {
        overflow: hidden;
        word-wrap: break-word;
        height: 2rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/form_elements/TextArea.vue